// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__T4jeB","title":"Header_title__i-6gp","side":"Header_side__1tlYK"};